// frontend/src/pages/admin/ShowUpdates.js
import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../services/api';

export default function ShowUpdates() {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    fetchUpdates();
  }, []);

  // ✅ Fetch show updates from backend
  const fetchUpdates = async () => {
    try {
      const res = await api.get('/admin/show-updates');
      setUpdates(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <AdminLayout>
      <h2 className="text-xl font-bold mb-4">Show Updates</h2>
      <ul className="bg-white p-4 rounded shadow space-y-3">
        {updates.map(u => (
          <li key={u.id} className="border-b pb-2">
            <strong>{u.eventName}</strong> — Status: {u.eventStatus} (Updated: {new Date(u.date).toLocaleString()})
          </li>
        ))}
      </ul>
    </AdminLayout>
  );
}
